import { createApiCall } from 'lib/base';

const PATCH_EDIT_STOCK_FUNDAMENTAL = 'PATCH_EDIT_STOCK_FUNDAMENTAL';

const editStockFundamentalApi = createApiCall<{ id: string; payload: any }>(
  PATCH_EDIT_STOCK_FUNDAMENTAL,
  ({ id, payload }) => ({
    endpoint: `api/admin/stock-fundamentals/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editStockFundamentalApi;
